import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { FormInputProps } from './types';
import { generatePlaceholderForInputField } from '../utils';

// components
import { Input } from '@ui';

const FormInput: React.FC<FormInputProps> = ({
  validationRules,
  placeholder: propsPlaceholder,
  renderPlaceholder,
  ...rest
}) => {
  const { t } = useTranslation('form');

  const placeholder = useMemo(() => {
    if (propsPlaceholder) {
      return propsPlaceholder;
    }

    if (renderPlaceholder) {
      return renderPlaceholder(validationRules || []);
    }

    return generatePlaceholderForInputField(validationRules || [], t);
  }, [validationRules, propsPlaceholder, renderPlaceholder]);

  return <Input {...rest} placeholder={placeholder} />;
};

export default React.memo(FormInput);
